import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../components/buttons/buttons";
import { getAnInfractionAction } from "../../../redux/infraction/infractionActions";
import UpdateInfractionModalModal from "../../../components/modals/admin/updateInfractionModal";

export default function SingleInfraction() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const { singleInfraction } = useSelector((state) => state.infraction);

  const closeModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(getAnInfractionAction(id));
    }
  }, [dispatch, id]);

  return (
    <>
      <div data-test="adminInfraction-page">
        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mb-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between gap-6 items-center">
            <h3 className="text-lg font-medium">Infraction Request Details</h3>
            <Button.Primary
              type={"button"}
              title={"Update Request Type"}
              onClick={() => setOpenModal(true)}
            />
          </div>

          <div className="mt-6">
            <p className="text-lg">{singleInfraction?.message}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 mt-12">
            <div>
              <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                Outlet:
              </label>
              <p className="text-[#151515] dark:text-white text-sm break-words">
                {singleInfraction?.store?.store_name ??
                  singleInfraction?.restaurant?.restaurant_name ??
                  "--"}
              </p>
            </div>
            <div>
              <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                Request Title:
              </label>
              <p className="text-[#151515] dark:text-white text-sm break-words">
                {singleInfraction?.title}
              </p>
            </div>
            <div>
              <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                Request Type:
              </label>
              <p className="text-[#151515] dark:text-white text-sm break-words">
                {singleInfraction?.type}
              </p>
            </div>
            <div>
              <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                Date:
              </label>
              <p className="text-[#151515] dark:text-white text-sm">
                {singleInfraction?.date}
              </p>
            </div>
            <div>
              <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                Created At:
              </label>
              <p className="text-[#151515] dark:text-white text-sm">
                {moment(singleInfraction?.created_at).format("hh:mm a")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {singleInfraction?.id && (
        <UpdateInfractionModalModal
          show={openModal}
          onClose={closeModal}
          id={singleInfraction?.id}
        />
      )}
    </>
  );
}
